import axios from "axios";

const useAxios = () => {
  const axiosPublic = axios.create({
    baseURL: "https://busy-ruby-sea-lion-tux.cyclic.app/book",
  });

  return { axiosPublic };
};

export default useAxios;
